const MAPA_API_BASE = "https://alerta-maceio-api-production.up.railway.app/api";

const CATS = [
  { id: "roubo", key: "catRoubo", icon: "ski-mask", tone: "alert" },
  { id: "veiculo", key: "catVeiculo", icon: "car", tone: "alert" },
  { id: "suspeito", key: "catSuspeito", icon: "eye", tone: "neutral" },
  { id: "arrombamento", key: "catArrombamento", icon: "door-closed", tone: "alert" },
  { id: "furto", key: "catFurto", icon: "wallet", tone: "warning" },
  { id: "trafico", key: "catTrafico", icon: "pill", tone: "warning" },
  { id: "agressao", key: "catAgressao", icon: "hand", tone: "alert" },
  { id: "vandalismo", key: "catVandalismo", icon: "hammer", tone: "warning" },
  { id: "outro", key: "catOutro", icon: "more-horizontal", tone: "neutral" },
];
const FILTERS = [
  { id: "24h", key: "filter24h" },
  { id: "7d", key: "filter7d" },
  { id: "30d", key: "filter30d" },
  { id: "90d", key: "filter90d" },
  { id: "180d", key: "filter180d", premium: true },
  { id: "365d", key: "filter365d", premium: true },
];
const H = 3600 * 1000, D = 24 * H;
function windowMs(id) { return { "24h": D, "7d": 7 * D, "30d": 30 * D, "90d": 90 * D, "180d": 180 * D, "365d": 365 * D }[id]; }
function timeAgoLabel(ts, lang) {
  const l = lang || "pt";
  const hours = Math.round((Date.now() - ts) / H);
  if (hours < 1) return l === "en" ? "just now" : l === "es" ? "justo ahora" : "agora há pouco";
  if (hours < 24) return l === "en" ? `${hours}h ago` : l === "es" ? `hace ${hours}h` : `há ${hours}h`;
  const days = Math.round((Date.now() - ts) / D);
  if (l === "en") return `${days} day${days > 1 ? "s" : ""} ago`;
  if (l === "es") return `hace ${days} día${days > 1 ? "s" : ""}`;
  return `há ${days} dia${days > 1 ? "s" : ""}`;
}
const MACEIO_BOUNDS = { west: -35.80, east: -35.69, north: -9.50, south: -9.71 };
function seedReports() {
  const now = Date.now();
  return [
    { id: "s1", category: "roubo", bairro: "Jaraguá", lat: -9.6706, lng: -35.7301, createdAt: now - 3 * H, confirms: 4 },
    { id: "s2", category: "furto", bairro: "Farol", lat: -9.6455, lng: -35.7231, createdAt: now - 20 * H, confirms: 2 },
    { id: "s3", category: "roubo", bairro: "Vergel do Lago", lat: -9.6274, lng: -35.7217, createdAt: now - 2 * D, confirms: 6 },
    { id: "s4", category: "outro", bairro: "Pajuçara", lat: -9.6636, lng: -35.7093, createdAt: now - 6 * D, confirms: 1 },
    { id: "s5", category: "furto", bairro: "Clima Bom", lat: -9.5763, lng: -35.7857, createdAt: now - 18 * D, confirms: 3 },
    { id: "s6", category: "trafico", bairro: "Tabuleiro dos Martins", lat: -9.5814, lng: -35.7419, createdAt: now - 40 * D, confirms: 5 },
    { id: "s7", category: "agressao", bairro: "Jacintinho", lat: -9.6242, lng: -35.7304, createdAt: now - 70 * D, confirms: 2 },
    { id: "s8", category: "veiculo", bairro: "Cidade Universitária", lat: -9.5535, lng: -35.7739, createdAt: now - 85 * D, confirms: 3 },
  ];
}

const TONE_COLOR = { alert: "#C81E2C", warning: "#C4841E", neutral: "#5C6B77" };
const ALERT_PLACE_COLOR = "#1F8A5E";
const SOURCE_OPTIONS = [
  { id: "all", key: "mapSourceAll", icon: "layers" },
  { id: "community", key: "mapSourceCommunity", icon: "users" },
  { id: "news", key: "mapSourceNews", icon: "newspaper" },
];
const MAP_SOURCE_KEY = "vigial_map_source_v1";
const HEATMAP_KEY = "vigial_map_heatmap_v1";
const TURNOS = [
  { id: "manha", key: "turnoManha", start: 6, end: 12 },
  { id: "tarde", key: "turnoTarde", start: 12, end: 18 },
  { id: "noite", key: "turnoNoite", start: 18, end: 24 },
  { id: "madrugada", key: "turnoMadrugada", start: 0, end: 6 },
];
const CUSTOM_ICON_URLS = { "ski-mask": "ski-mask.svg" };
function catIconUrl(icon) {
  return CUSTOM_ICON_URLS[icon] || `https://unpkg.com/lucide-static@0.462.0/icons/${icon}.svg`;
}
window.catIconUrl = catIconUrl;

function stripAccentsJs(s) {
  const norm = (s || "").normalize("NFD");
  let out = "";
  for (let i = 0; i < norm.length; i++) {
    const code = norm.charCodeAt(i);
    if (code < 0x0300 || code > 0x036f) out += norm[i];
  }
  return out.toLowerCase();
}
// Multiple news/reports in the same bairro can share the exact same
// coordinates (the bairro centroid), stacking pins on top of each other.
// Returns a fixed-pixel [dx, dy] per item so duplicates fan out on screen
// by a constant amount regardless of zoom level (a geo-offset would shrink
// to nothing when zoomed out and overlap again).
function spreadOverlappingPoints(items, getLat, getLng) {
  const groups = {};
  items.forEach((item, idx) => {
    const key = `${getLat(item).toFixed(5)},${getLng(item).toFixed(5)}`;
    (groups[key] || (groups[key] = [])).push(idx);
  });
  const offsets = items.map(() => [0, 0]);
  const PIXEL_RADIUS = 11;
  Object.values(groups).forEach((idxs) => {
    if (idxs.length <= 1) return;
    idxs.forEach((idx, i) => {
      const angle = (2 * Math.PI * i) / idxs.length;
      offsets[idx] = [PIXEL_RADIUS * Math.sin(angle), -PIXEL_RADIUS * Math.cos(angle)];
    });
  });
  return offsets;
}

function pointInPolygon(lat, lng, rings) {
  const ring = rings[0];
  let inside = false;
  for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
    const [xi, yi] = ring[i];
    const [xj, yj] = ring[j];
    const intersect = yi > lat !== yj > lat && lng < ((xj - xi) * (lat - yi)) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
}
// Deterministic (no Math.random, so pins don't jump around on re-render)
// placement of `count` points around a bairro's own polygon shape.
function spreadInPolygon(rings, count, fallbackLat, fallbackLng) {
  const ring = rings[0];
  const lons = ring.map((p) => p[0]);
  const lats = ring.map((p) => p[1]);
  const cLat = (Math.min(...lats) + Math.max(...lats)) / 2;
  const cLng = (Math.min(...lons) + Math.max(...lons)) / 2;
  const maxRLat = (Math.max(...lats) - Math.min(...lats)) / 2;
  const maxRLng = (Math.max(...lons) - Math.min(...lons)) / 2;
  const points = [];
  for (let i = 0; i < count; i++) {
    const angle = (2 * Math.PI * i) / count + 0.35;
    let found = null;
    // Bairros are often narrow/irregular, so a point at the "ideal" radius
    // can miss the actual shape; shrink toward the center until one lands
    // inside instead of collapsing every miss onto the same fallback spot
    // (which just recreates the original stacking bug for 2+ items).
    for (const scale of [0.55, 0.42, 0.3, 0.18, 0.08]) {
      const lat = cLat + maxRLat * scale * Math.sin(angle);
      const lng = cLng + maxRLng * scale * Math.cos(angle);
      if (pointInPolygon(lat, lng, rings)) { found = [lat, lng]; break; }
    }
    if (!found) {
      const jitterAngle = angle + 0.6;
      found = [
        fallbackLat + 0.00035 * (i + 1) * Math.sin(jitterAngle),
        fallbackLng + 0.00035 * (i + 1) * Math.cos(jitterAngle),
      ];
    }
    points.push(found);
  }
  return points;
}
const NEWS_CLUSTER_THRESHOLD = 3;
const HEAT_COLOR_STOPS = [
  [0.0, [63, 166, 92]],
  [0.34, [230, 193, 61]],
  [0.67, [224, 138, 46]],
  [1.0, [200, 30, 44]],
];
function rankToColor(rank) {
  for (let i = 0; i < HEAT_COLOR_STOPS.length - 1; i++) {
    const [r0, c0] = HEAT_COLOR_STOPS[i];
    const [r1, c1] = HEAT_COLOR_STOPS[i + 1];
    if (rank >= r0 && rank <= r1) {
      const t = (rank - r0) / (r1 - r0);
      const c = c0.map((v, idx) => Math.round(v + (c1[idx] - v) * t));
      return `rgb(${c[0]},${c[1]},${c[2]})`;
    }
  }
  const last = HEAT_COLOR_STOPS[HEAT_COLOR_STOPS.length - 1][1];
  return `rgb(${last[0]},${last[1]},${last[2]})`;
}
// Bairros with a well-documented, persistent history of violent crime in
// Maceió (real-world local knowledge, not something derivable from our own
// still-sparse in-app data). A pure percentile ranking can rank one of these
// green just because nobody has filed a report/news hit for it yet — that
// reads as "safe", which is both wrong and the opposite of what this map is
// for. This floor keeps them at least light yellow no matter how thin our
// data is; real data can still push a bairro higher than the floor.
const VULNERABLE_BAIRROS = [
  "clima bom", "benedito bentes", "cidade universitaria", "tabuleiro dos martins",
  "salvador lyra", "vergel do lago", "riacho doce", "pescaria", "jacintinho",
  "feitosa", "mutange", "bebedouro", "bom parto", "barro duro",
  "cha da jaqueira", "cha de bebedouro", "santos dumont", "santa lucia",
].map(stripAccentsJs);
const VULNERABLE_RANK_FLOOR = 0.3;
// How fast a single occurrence's contribution to the heatmap fades — a
// bairro should visibly pull toward red right after something happens, then
// cool back down on its own as time passes without anything new, instead of
// just falling off a cliff the instant it scrolls outside the selected
// time-window tab. 42h was picked as a middle ground: noticeably cooler
// after a day, still has some warmth left after two — adjust this one
// constant to make the whole map heat up/cool down faster or slower.
const HEAT_HALF_LIFE_MS = 42 * 3600 * 1000;
function decayWeight(ageMs) {
  return Math.pow(0.5, ageMs / HEAT_HALF_LIFE_MS);
}
// How much total decayed heat it takes to reach "fully red" — tuned so one
// fresh occurrence lands around rank 0.35 (yellow), three around 0.73
// (orange-red), five or more saturates near 1.0 (full red). Kept as a
// saturating curve (rank = 1 - e^-heat/HEAT_SCALE) rather than the percentile
// approach this replaced: percentile ranking only ever compares bairros to
// each other, so a single occurrence — even after it's decayed to a sliver
// of its original weight — still outranks every untouched-today bairro
// forever, since "a sliver more than zero" is still the max of the set.
// That never visually cools back to green, which defeats the point. An
// absolute scale genuinely settles back toward green as `heat` itself decays.
const HEAT_SCALE = 2.3;
function heatToRank(heat) {
  return 1 - Math.exp(-heat / HEAT_SCALE);
}
// Every bairro in `allBairroKeys` gets a rank — including ones with zero
// recent occurrences — so the map never falls back to the flat "no data"
// gray; a bairro with nothing going on just settles at the calm (green) end
// of the scale (heat 0 -> rank 0), same as everywhere else.
function computeBairroRanks(items, allBairroKeys, now) {
  const counts = {};
  const heat = {};
  items.forEach((item) => {
    if (!item.bairro) return;
    const ts = item.createdAt || item.publishedAt;
    if (!ts) return;
    const key = stripAccentsJs(item.bairro);
    counts[key] = (counts[key] || 0) + 1;
    heat[key] = (heat[key] || 0) + decayWeight(Math.max(0, now - ts));
  });
  const rankByKey = {};
  allBairroKeys.forEach((key) => {
    rankByKey[key] = heatToRank(heat[key] || 0);
  });
  VULNERABLE_BAIRROS.forEach((key) => {
    if (key in rankByKey) rankByKey[key] = Math.max(rankByKey[key], VULNERABLE_RANK_FLOOR);
  });
  return { counts, rankByKey };
}

const RELATED_NEWS_MAX_GAP_MS = 4 * 24 * 3600 * 1000;
function findRelatedNews(report, newsList) {
  if (!report.bairro || !newsList || !newsList.length) return null;
  const target = stripAccentsJs(report.bairro);
  return newsList.find((n) => {
    if (!n.bairro || stripAccentsJs(n.bairro) !== target) return false;
    if (!n.publishedAt) return false;
    return Math.abs(report.createdAt - n.publishedAt) <= RELATED_NEWS_MAX_GAP_MS;
  }) || null;
}
function badgeHtml(text) {
  return `<span style="display:inline-block;font-size:10px;font-weight:600;padding:1px 7px;border-radius:999px;background:var(--color-brand-tint);color:var(--color-brand-deep);margin-bottom:4px;">${text}</span>`;
}
// The share button is an onclick attribute calling a global bridge function
// (registered on window by MapaScreen) instead of a real React handler,
// because Leaflet popups are plain HTML strings, not React nodes. `argExpr`
// is a ready-to-use JS argument expression (a quoted string literal for
// id-based lookups, a bare number for index-based ones) — never raw
// untrusted text, since it's spliced straight into an inline onclick.
function shareButtonHtml(lang, fnName, argExpr) {
  return `<br><button onclick="window.${fnName}(${argExpr})" style="margin-top:6px;display:inline-flex;align-items:center;gap:5px;background:transparent;border:1px solid var(--color-border);border-radius:999px;padding:4px 10px;font-size:11px;cursor:pointer;color:var(--color-brand-primary);font-family:inherit;"><span style="display:inline-block;width:11px;height:11px;background-color:var(--color-brand-primary);-webkit-mask-image:url('https://unpkg.com/lucide-static@0.462.0/icons/share-2.svg');mask-image:url('https://unpkg.com/lucide-static@0.462.0/icons/share-2.svg');-webkit-mask-size:contain;mask-size:contain;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;-webkit-mask-position:center;mask-position:center;"></span>${t(lang, "shareToCommunityBtn")}</button>`;
}
// Same window.<fn> bridge pattern as shareButtonHtml — the popup itself is
// plain HTML, so voting from it has to call back into React via a global.
function voteButtonsHtml(lang, reportId, confirms, canDownvote) {
  const safeId = escapeHtml(reportId);
  const dislikeBtn = canDownvote
    ? `<button onclick="window.vigiDislikeReport('${safeId}')" style="background:transparent;border:1px solid var(--color-border);border-radius:999px;padding:4px 8px;font-size:11px;cursor:pointer;color:var(--color-text-secondary);font-family:inherit;">👎</button>`
    : `<button disabled title="${escapeHtml(t(lang, "downvoteNeedsVerifiedHint"))}" style="background:transparent;border:1px solid var(--color-border);border-radius:999px;padding:4px 8px;font-size:11px;cursor:not-allowed;opacity:.4;color:var(--color-text-secondary);font-family:inherit;">👎</button>`;
  return `<br><div style="margin-top:6px;display:flex;gap:6px;">
    <button onclick="window.vigiConfirmReport('${safeId}')" style="background:transparent;border:1px solid var(--color-border);border-radius:999px;padding:4px 8px;font-size:11px;cursor:pointer;color:var(--color-text-secondary);font-family:inherit;">👍 ${confirms}</button>
    ${dislikeBtn}
  </div>`;
}
// Popups are built as raw HTML strings for Leaflet's bindPopup, so any
// field that isn't a fixed app string (report bairro/category text, news
// titles, etc.) must be escaped before interpolation — the backend
// validates report bairro against the official list now, but this is the
// last line of defense against stored XSS via that or any future field.
function escapeHtml(text) {
  return String(text == null ? "" : text).replace(/[&<>"']/g, (c) => (
    { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]
  ));
}

function OccurrenceRowCard({ lang, label, timeAgo, confirms, tone, onConfirm, onDislike, onLocate, related, guardianConfirmed, canDownvote }) {
  const { Icon } = window.VigiALDesignSystem_ff2dec;
  const dot = TONE_COLOR[tone] || TONE_COLOR.neutral;
  return (
    <div style={{ border: "1px solid var(--color-border)", borderRadius: "var(--radius-lg)", padding: "8px 10px", marginBottom: 6, fontFamily: "var(--font-body)" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
          <span style={{ width: 8, height: 8, borderRadius: "50%", background: dot, flexShrink: 0 }} />
          <div style={{ minWidth: 0 }}>
            <span style={{ fontSize: "var(--text-xs)", fontWeight: "var(--weight-semibold)", color: "var(--color-brand-deep)", background: "var(--color-brand-tint)", borderRadius: "var(--radius-pill)", padding: "1px 7px" }}>{t(lang, "sourceCommunity")}</span>
            <div style={{ fontSize: "var(--text-base)" }}>{label}</div>
            <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", fontFamily: "var(--font-mono)" }}>{timeAgo}</div>
            {guardianConfirmed && (
              <div style={{ display: "flex", alignItems: "center", gap: 3, fontSize: "var(--text-xs)", color: "#D4AF37", fontWeight: 600 }}>
                <Icon name="crown" size={11} color="#D4AF37" /> {t(lang, "guardianConfirmedBadge")}
              </div>
            )}
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 4, flexShrink: 0 }}>
          <button onClick={onLocate} title={t(lang, "viewOnMap")} style={{ background: "transparent", border: "1px solid var(--color-border)", borderRadius: "var(--radius-pill)", padding: "4px 7px", display: "flex", alignItems: "center", cursor: "pointer" }}>
            <Icon name="map-pin" size={13} color="var(--color-text-secondary)" />
          </button>
          <button onClick={onConfirm} style={{ background: "transparent", border: "1px solid var(--color-border)", borderRadius: "var(--radius-pill)", padding: "4px 8px", fontSize: "var(--text-sm)", display: "flex", alignItems: "center", gap: 3, color: "var(--color-text-secondary)", cursor: "pointer" }}>
            👍 {confirms}
          </button>
          <button
            onClick={canDownvote ? onDislike : undefined}
            disabled={!canDownvote}
            title={canDownvote ? undefined : t(lang, "downvoteNeedsVerifiedHint")}
            style={{ background: "transparent", border: "1px solid var(--color-border)", borderRadius: "var(--radius-pill)", padding: "4px 8px", fontSize: "var(--text-sm)", display: "flex", alignItems: "center", cursor: canDownvote ? "pointer" : "not-allowed", opacity: canDownvote ? 1 : 0.4 }}
          >
            👎
          </button>
        </div>
      </div>
      {related && (
        <a href={related.link} onClick={(e) => { e.preventDefault(); window.vigiOpenNewsArticle(related.link); }} target="_blank" rel="noreferrer" style={{ display: "inline-flex", alignItems: "center", gap: 4, marginTop: 6, marginLeft: 16, fontSize: "var(--text-xs)", color: "var(--color-brand-primary)" }}>
          <Icon name="external-link" size={11} color="var(--color-brand-primary)" /> {t(lang, "relatedNews")} ({related.outlet})
        </a>
      )}
    </div>
  );
}

function NewsRowCard({ lang, n }) {
  const { Icon } = window.VigiALDesignSystem_ff2dec;
  return (
    <div style={{ border: "1px solid var(--color-border)", borderRadius: "var(--radius-lg)", padding: "8px 10px", marginBottom: 6, fontFamily: "var(--font-body)" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
        <span style={{ width: 8, height: 8, borderRadius: "50%", background: "var(--color-brand-primary)", flexShrink: 0 }} />
        <div style={{ minWidth: 0, flex: 1 }}>
          <span style={{ fontSize: "var(--text-xs)", fontWeight: "var(--weight-semibold)", color: "var(--color-brand-deep)", background: "var(--color-brand-tint)", borderRadius: "var(--radius-pill)", padding: "1px 7px" }}>{n.outlet}</span>
          <div style={{ fontSize: "var(--text-base)" }}>{n.title}{n.bairro ? ` · ${n.bairro}` : ""}</div>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
            <span style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", fontFamily: "var(--font-mono)" }}>{timeAgoLabel(n.publishedAt, lang)}</span>
            <a href={n.link} onClick={(e) => { e.preventDefault(); window.vigiOpenNewsArticle(n.link); }} target="_blank" rel="noreferrer" style={{ display: "inline-flex", alignItems: "center", gap: 4, fontSize: "var(--text-xs)", color: "var(--color-brand-primary)", flexShrink: 0 }}>
              <Icon name="external-link" size={11} color="var(--color-brand-primary)" /> {t(lang, "readFullArticleAt")} {n.outlet}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

function ShareToCommunityModal({ lang, report, onClose, showToast }) {
  const { Modal, Button, Icon } = window.VigiALDesignSystem_ff2dec;
  const deviceId = window.getDeviceId ? window.getDeviceId() : null;
  const premium = window.isPremium ? window.isPremium() : false;
  const [verifiedEmail, setVerifiedEmail] = React.useState(undefined);
  const [communities, setCommunities] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [selectedId, setSelectedId] = React.useState(null);
  const [saving, setSaving] = React.useState(false);
  const [error, setError] = React.useState("");
  const [done, setDone] = React.useState(false);

  React.useEffect(() => {
    if (!deviceId || !premium) { setLoading(false); return; }
    fetch(`${MAPA_API_BASE}/device-trust/mine`, {
      method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ deviceId }),
    })
      .then((r) => r.json())
      .then((d) => setVerifiedEmail(d.verifiedEmail || null))
      .catch(() => setVerifiedEmail(null));
    fetch(`${MAPA_API_BASE}/communities/mine`, {
      method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ deviceId }),
    })
      .then((r) => r.json())
      .then((data) => { setCommunities(Array.isArray(data) ? data : []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  async function handleShare() {
    if (!selectedId || !report) return;
    setSaving(true);
    setError("");
    try {
      const res = await fetch(`${MAPA_API_BASE}/community-pins`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          deviceId, communityId: selectedId, category: report.communityCategory,
          title: report.title, description: t(lang, "sharedFromMapDesc"), lat: report.lat, lng: report.lng,
          sourceUrl: report.sourceUrl || undefined,
        }),
      }).then((r) => r.json());
      if (res.error) { setError(res.error); setSaving(false); return; }
      setDone(true);
      if (showToast) showToast(t(lang, "sharedToCommunitySuccess"));
    } catch (e) {
      setError(t(lang, "comGenericError"));
    }
    setSaving(false);
  }

  return (
    <Modal title={t(lang, "shareToCommunityTitle")} onClose={onClose} width={320}>
      <div style={{ padding: "10px 16px 16px" }}>
        {!premium && (
          <div style={{ fontSize: "var(--text-sm)", color: "var(--color-text-secondary)" }}>{t(lang, "comPremiumGateBody")}</div>
        )}

        {premium && (verifiedEmail === undefined || loading) && (
          <div style={{ fontSize: "var(--text-sm)", color: "var(--color-text-muted)" }}>{t(lang, "comLoading")}</div>
        )}

        {premium && verifiedEmail === null && (
          <div style={{ fontSize: "var(--text-sm)", color: "var(--color-text-secondary)" }}>{t(lang, "comNeedsVerifiedEmail")}</div>
        )}

        {verifiedEmail && !loading && !done && (
          <React.Fragment>
            {communities.length === 0 ? (
              <div style={{ fontSize: "var(--text-sm)", color: "var(--color-text-muted)" }}>{t(lang, "shareNoCommunitiesHint")}</div>
            ) : (
              <React.Fragment>
                <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", marginBottom: 8 }}>{t(lang, "shareChooseCommunityHint")}</div>
                {communities.map((c) => (
                  <button
                    key={c.id}
                    onClick={() => setSelectedId(c.id)}
                    style={{
                      width: "100%", textAlign: "left", display: "flex", alignItems: "center", justifyContent: "space-between",
                      border: selectedId === c.id ? "1px solid var(--color-brand-primary)" : "1px solid var(--color-border)",
                      background: selectedId === c.id ? "var(--color-brand-tint)" : "transparent",
                      borderRadius: "var(--radius-lg)", padding: 10, marginBottom: 6, cursor: "pointer", fontFamily: "var(--font-body)",
                    }}
                  >
                    <span style={{ fontSize: "var(--text-sm)", fontWeight: 600, color: selectedId === c.id ? "var(--color-brand-deep)" : "var(--color-text-primary)" }}>{c.name}</span>
                    {selectedId === c.id && <Icon name="check" size={14} color="var(--color-brand-deep)" />}
                  </button>
                ))}
                {error && <div style={{ fontSize: "var(--text-xs)", color: "var(--color-alert)", marginTop: 6 }}>{error}</div>}
                <Button variant="primary" onClick={handleShare} disabled={!selectedId || saving} style={{ width: "100%", marginTop: 10 }}>
                  {t(lang, "shareBtn")}
                </Button>
              </React.Fragment>
            )}
          </React.Fragment>
        )}

        {done && (
          <React.Fragment>
            <div style={{ fontSize: "var(--text-sm)", color: "var(--color-text-primary)", marginBottom: 10 }}>{t(lang, "sharedToCommunitySuccess")}</div>
            <Button variant="primary" onClick={onClose} style={{ width: "100%" }}>{t(lang, "comDoneBtn")}</Button>
          </React.Fragment>
        )}
      </div>
    </Modal>
  );
}

function MapaScreen({ lang, filter, setFilter, reports, onConfirm, onDislike, onOpenReport, showToast, myTrustLevel, showSignupBanner, onDismissSignupBanner }) {
  const { Chip, Button, MapLegend, Icon, Modal } = window.VigiALDesignSystem_ff2dec;
  const premium = window.isPremium ? window.isPremium() : false;
  const visibleFilters = FILTERS.filter((f) => !f.premium || premium);
  const mapDivRef = React.useRef(null);
  const mapRef = React.useRef(null);
  const markersRef = React.useRef([]);
  const markersByIdRef = React.useRef({});
  const newsMarkersRef = React.useRef([]);
  const alertMarkersRef = React.useRef([]);
  const alertCirclesRef = React.useRef([]);
  const hasAutoFitRef = React.useRef(false);
  const userMarkerRef = React.useRef(null);
  const userAccuracyCircleRef = React.useRef(null);
  const locateBtnRef = React.useRef(null);
  const locateMeRef = React.useRef(() => {});
  const generalNewsBtnRef = React.useRef(null);
  const generalNewsOpenRef = React.useRef(() => {});
  const choroplethLayersRef = React.useRef([]);
  const reportsRef = React.useRef(reports);
  const placesRef = React.useRef([]);
  const newsRef = React.useRef([]);
  const [locating, setLocating] = React.useState(false);
  const [shareReport, setShareReport] = React.useState(null);
  const [news, setNews] = React.useState([]);
  const [generalNewsOpen, setGeneralNewsOpen] = React.useState(false);
  const [bairroPolygons, setBairroPolygons] = React.useState(null);
  const [sourceFilter, setSourceFilter] = React.useState(() => {
    try { return localStorage.getItem(MAP_SOURCE_KEY) || "all"; } catch (e) { return "all"; }
  });
  const [sourceMenuOpen, setSourceMenuOpen] = React.useState(false);
  const [showHeatmap, setShowHeatmap] = React.useState(() => {
    // Defaults to on (unlike most toggles here) — the heatmap is the more
    // immediately useful view for a first-time visitor, and it's still a
    // normal toggle from here on, this only changes the first-ever value.
    try {
      const saved = localStorage.getItem(HEATMAP_KEY);
      return saved === null ? true : saved === "1";
    } catch (e) { return true; }
  });
  const [exploreByHour, setExploreByHour] = React.useState(false);
  const [turno, setTurno] = React.useState("noite");

  React.useEffect(() => { reportsRef.current = reports; }, [reports]);

  React.useEffect(() => {
    // Three separate bridges (crime reports, saved places/bairros, news)
    // because each source array is keyed/shaped differently — reports have
    // a stable id, places and news don't, so those two are looked up by
    // index into the same array the currently-open popups were built from.
    // All three end up producing the same normalized shape the share modal
    // expects: { lat, lng, title, communityCategory }. Depends on `lang` so
    // the title text stays in the current language after a language switch.
    window.vigiShareReportToCommunity = (reportId) => {
      const rep = reportsRef.current.find((r) => r.id === reportId);
      if (!rep) return;
      const cat = CATS.find((c) => c.id === rep.category) || CATS.find((c) => c.id === "outro");
      const title = rep.bairro ? `${t(lang, cat.key)} · ${rep.bairro}` : t(lang, cat.key);
      setShareReport({ lat: rep.lat, lng: rep.lng, title, communityCategory: "ocorrencia" });
    };
    window.vigiShareAlertPlaceToCommunity = (idx) => {
      const p = placesRef.current[idx];
      if (!p) return;
      setShareReport({ lat: p.lat, lng: p.lng, title: p.name, communityCategory: "aviso" });
    };
    window.vigiShareNewsToCommunity = (idx) => {
      const n = newsRef.current[idx];
      if (!n) return;
      setShareReport({ lat: n.lat, lng: n.lng, title: n.title, communityCategory: "aviso", sourceUrl: n.link });
    };
    window.vigiConfirmReport = (reportId) => onConfirm(reportId);
    window.vigiDislikeReport = (reportId) => onDislike(reportId);
    return () => {
      delete window.vigiShareReportToCommunity;
      delete window.vigiShareAlertPlaceToCommunity;
      delete window.vigiShareNewsToCommunity;
      delete window.vigiConfirmReport;
      delete window.vigiDislikeReport;
    };
  }, [lang, onConfirm, onDislike]);

  React.useEffect(() => {
    try { localStorage.setItem(MAP_SOURCE_KEY, sourceFilter); } catch (e) {}
  }, [sourceFilter]);

  React.useEffect(() => {
    try { localStorage.setItem(HEATMAP_KEY, showHeatmap ? "1" : "0"); } catch (e) {}
  }, [showHeatmap]);

  React.useEffect(() => {
    if (!mapDivRef.current || mapRef.current) return;
    const map = L.map(mapDivRef.current, { zoomControl: true, scrollWheelZoom: true, touchZoom: true, attributionControl: true });
    // Leaflet's attribution defaults to bottomright, prefixed with a
    // "Leaflet" link — shortened here (prefix removed) so it fits beside
    // MapLegend (bottom-left, see _ds_bundle.js) instead of overlapping it;
    // both were previously anchored full-width to the same bottom edge of
    // this short (240px) map box.
    map.attributionControl.setPrefix(false);
    map.fitBounds([[MACEIO_BOUNDS.south, MACEIO_BOUNDS.west], [MACEIO_BOUNDS.north, MACEIO_BOUNDS.east]]);
    L.tileLayer(window.VIGI_TILE_URL, window.VIGI_TILE_OPTIONS).addTo(map);
    const LocateControl = L.Control.extend({
      options: { position: "topleft" },
      onAdd: function () {
        const container = L.DomUtil.create("div", "leaflet-bar vigi-locate-control");
        const btn = L.DomUtil.create("a", "", container);
        btn.href = "#";
        btn.innerHTML = '<span class="vigi-locate-icon"></span>';
        L.DomEvent.on(btn, "click", (e) => {
          L.DomEvent.preventDefault(e);
          L.DomEvent.stopPropagation(e);
          locateMeRef.current();
        });
        locateBtnRef.current = btn;
        return container;
      },
    });
    new LocateControl().addTo(map);
    const RecenterControl = L.Control.extend({
      options: { position: "topleft" },
      onAdd: function () {
        const container = L.DomUtil.create("div", "leaflet-bar vigi-recenter-control");
        const btn = L.DomUtil.create("a", "", container);
        btn.href = "#";
        btn.title = t(lang, "recenterMapBtn");
        btn.innerHTML = '<span class="vigi-recenter-icon"></span>';
        L.DomEvent.on(btn, "click", (e) => {
          L.DomEvent.preventDefault(e);
          L.DomEvent.stopPropagation(e);
          map.fitBounds([[MACEIO_BOUNDS.south, MACEIO_BOUNDS.west], [MACEIO_BOUNDS.north, MACEIO_BOUNDS.east]]);
        });
        return container;
      },
    });
    new RecenterControl().addTo(map);
    const GeneralNewsControl = L.Control.extend({
      options: { position: "topleft" },
      onAdd: function () {
        const container = L.DomUtil.create("div", "leaflet-bar vigi-general-news-control");
        const btn = L.DomUtil.create("a", "", container);
        btn.href = "#";
        btn.innerHTML = '<span class="vigi-general-news-icon"></span><span class="vigi-general-news-badge"></span>';
        L.DomEvent.on(btn, "click", (e) => {
          L.DomEvent.preventDefault(e);
          L.DomEvent.stopPropagation(e);
          generalNewsOpenRef.current();
        });
        container.style.display = "none";
        generalNewsBtnRef.current = container;
        return container;
      },
    });
    new GeneralNewsControl().addTo(map);
    // The topleft corner control stack (zoom + locate + recenter + news) sits
    // in its own stacking context (Leaflet CSS-transforms the map pane for
    // panning, which traps any popup z-index below it) — a popup opening near
    // that corner on this short 240px map has nowhere to auto-pan to without
    // ending up disconnected from its marker. Simplest fix that doesn't move
    // the map: just fade those specific buttons out while a popup is open.
    const topLeftControls = mapDivRef.current.querySelector(".leaflet-top.leaflet-left");
    map.on("popupopen", () => { if (topLeftControls) topLeftControls.classList.add("vigi-controls-faded"); });
    map.on("popupclose", () => { if (topLeftControls) topLeftControls.classList.remove("vigi-controls-faded"); });
    mapRef.current = map;
  }, []);

  React.useEffect(() => {
    const map = mapRef.current;
    if (!map) return;
    let places = [];
    try { places = JSON.parse(localStorage.getItem(window.PLACES_KEY || "vigial_saved_places_v1") || "[]"); } catch (e) {}
    placesRef.current = places;
    alertMarkersRef.current.forEach((m) => map.removeLayer(m));
    alertCirclesRef.current.forEach((c) => map.removeLayer(c));
    function makeAlertIcon(iconName) {
      return L.divIcon({
        className: "",
        html: `<div style="width:22px;height:22px;border-radius:50%;background:${ALERT_PLACE_COLOR};border:2px solid #fff;box-shadow:var(--shadow-card);display:flex;align-items:center;justify-content:center;"><span style="display:inline-block;width:12px;height:12px;background-color:#fff;-webkit-mask-image:url('https://unpkg.com/lucide-static@0.462.0/icons/${iconName}.svg');mask-image:url('https://unpkg.com/lucide-static@0.462.0/icons/${iconName}.svg');-webkit-mask-size:contain;mask-size:contain;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;-webkit-mask-position:center;mask-position:center;"></span></div>`,
        iconSize: [22, 22],
        iconAnchor: [11, 11],
      });
    }
    const alertIcon = makeAlertIcon("shield");
    const bairroAlertIcon = makeAlertIcon("map");
    alertMarkersRef.current = places.map((p, idx) => {
      const marker = L.marker([p.lat, p.lng], { icon: p.isBairro ? bairroAlertIcon : alertIcon }).addTo(map);
      const safeName = escapeHtml(p.name);
      const bodyHtml = p.isBairro ? `<b>${safeName}</b>` : `<b>${safeName}</b><br>${p.radius}${t(lang, "meters")}`;
      marker.bindPopup(`${badgeHtml(t(lang, p.isBairro ? "tabMeuBairro" : "myAlertPlace"))}<br>${bodyHtml}${shareButtonHtml(lang, "vigiShareAlertPlaceToCommunity", idx)}`);
      return marker;
    });
    alertCirclesRef.current = places.map((p) => {
      if (p.isBairro && bairroPolygons) {
        const matchName = Object.keys(bairroPolygons).find((k) => stripAccentsJs(k) === stripAccentsJs(p.name));
        const rings = matchName ? bairroPolygons[matchName] : null;
        if (rings) {
          const latlngRings = rings.map((ring) => ring.map(([lng, lat]) => [lat, lng]));
          return L.polygon(latlngRings, {
            color: ALERT_PLACE_COLOR, weight: 2.5, dashArray: "7,6", fillColor: ALERT_PLACE_COLOR, fillOpacity: 0.05,
          }).addTo(map);
        }
      }
      return L.circle([p.lat, p.lng], { radius: p.radius, color: ALERT_PLACE_COLOR, weight: 1.2, fillColor: ALERT_PLACE_COLOR, fillOpacity: 0.07 }).addTo(map);
    });
  }, [lang, bairroPolygons]);

  React.useEffect(() => {
    fetch(`https://alerta-maceio-api-production.up.railway.app/api/news?window=${filter}`)
      .then((r) => r.json())
      .then((data) => setNews((data || []).filter((n) => n.lat != null && n.lng != null)))
      .catch(() => {});
  }, [filter]);

  React.useEffect(() => {
    fetch("bairro_polygons.json")
      .then((r) => r.json())
      .then(setBairroPolygons)
      .catch(() => {});
  }, []);

  React.useEffect(() => {
    const map = mapRef.current;
    if (!map) return;
    markersRef.current.forEach((m) => map.removeLayer(m));
    if (sourceFilter === "news") {
      markersRef.current = [];
      markersByIdRef.current = {};
      return;
    }
    const byId = {};

    if (exploreByHour) {
      const turnoDef = TURNOS.find((tu) => tu.id === turno) || TURNOS[2];
      const hourReports = reports.filter((r) => {
        const hr = new Date(r.createdAt).getHours();
        return hr >= turnoDef.start && hr < turnoDef.end;
      });
      const hourOffsets = spreadOverlappingPoints(hourReports, (r) => r.lat, (r) => r.lng);
      markersRef.current = hourReports.map((r, idx) => {
        const cat = CATS.find((c) => c.id === r.category) || CATS.find((c) => c.id === "outro");
        const [px, py] = hourOffsets[idx];
        const icon = L.divIcon({
          className: "",
          html: `<div style="width:12px;height:12px;border-radius:50%;background:${TONE_COLOR[cat.tone]};opacity:0.75;border:1.5px solid #fff;box-shadow:0 1px 3px rgba(0,0,0,.35);transform:translate(${px}px,${py}px)"></div>`,
          iconSize: [12, 12],
          iconAnchor: [6, 6],
        });
        const marker = L.marker([r.lat, r.lng], { icon }).addTo(map);
        marker.bindPopup(`${badgeHtml(t(lang, "sourceCommunity"))}<br><b>${t(lang, cat.key)}</b><br>${escapeHtml(r.bairro)}<br>${timeAgoLabel(r.createdAt, lang)}${voteButtonsHtml(lang, r.id, r.confirms || 0, (myTrustLevel || 0) >= 1)}${shareButtonHtml(lang, "vigiShareReportToCommunity", `'${escapeHtml(r.id)}'`)}`);
        byId[r.id] = marker;
        return marker;
      });
      markersByIdRef.current = byId;
      return;
    }

    const reportOffsets = spreadOverlappingPoints(reports, (r) => r.lat, (r) => r.lng);
    markersRef.current = reports.map((r, idx) => {
      const cat = CATS.find((c) => c.id === r.category) || CATS.find((c) => c.id === "outro");
      const stage = r.stage || "critical";
      const confirms = r.confirms || 0;
      const isUnverified = stage === "critical" && (r.reporterTrustLevel || 0) === 0 && confirms <= 0;
      const pinColor = stage === "attention" ? TONE_COLOR.warning : isUnverified ? "#7C8894" : TONE_COLOR[cat.tone];
      const showPulse = stage === "critical" && !isUnverified;
      const pinOpacity = isUnverified ? 0.6 : stage === "historical" ? 0.75 : 1;
      const [px, py] = reportOffsets[idx];
      const icon = L.divIcon({
        className: "",
        html: `<div class="vigi-map-pin${showPulse ? " pulse" : ""}" style="background:${pinColor};opacity:${pinOpacity};transform:translate(${px}px,${py}px)"><span style="display:inline-block;width:11px;height:11px;background-color:#fff;-webkit-mask-image:url('${catIconUrl(cat.icon)}');mask-image:url('${catIconUrl(cat.icon)}');-webkit-mask-size:contain;mask-size:contain;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;-webkit-mask-position:center;mask-position:center;"></span></div>`,
        iconSize: [20, 20],
        iconAnchor: [10, 10],
      });
      const marker = L.marker([r.lat, r.lng], { icon }).addTo(map);
      const related = findRelatedNews(r, news);
      const safeRelatedLink = related ? escapeHtml(related.link) : "";
      const relatedHtml = related ? `<br><a href="${safeRelatedLink}" data-link="${safeRelatedLink}" onclick="window.vigiOpenNewsArticle(this.getAttribute('data-link'));return false;" rel="noreferrer">${t(lang, "relatedNews")} (${escapeHtml(related.outlet)}) →</a>` : "";
      const trustHtml = isUnverified
        ? `<br><span style="color:var(--color-text-muted);font-size:11px;">${t(lang, "reportUnverifiedHint")}</span>`
        : confirms > 0
        ? `<br><span style="color:var(--color-brand-primary);font-size:11px;font-weight:600;">${t(lang, "reportVerifiedByPrefix")} ${confirms} ${t(lang, "reportVerifiedBySuffix")}</span>`
        : "";
      const stageHtml = stage === "attention"
        ? `<br><span style="color:var(--color-warning);font-size:11px;">${t(lang, "reportAttentionStageHint")}</span>`
        : stage === "historical"
        ? `<br><span style="color:var(--color-text-muted);font-size:11px;">${t(lang, "reportHistoricalStageHint")}</span>`
        : "";
      const guardianHtml = r.guardianConfirmed
        ? `<br><span style="display:inline-flex;align-items:center;gap:3px;color:#D4AF37;font-size:11px;font-weight:600;"><span style="display:inline-block;width:11px;height:11px;background-color:#D4AF37;-webkit-mask-image:url('https://unpkg.com/lucide-static@0.462.0/icons/crown.svg');mask-image:url('https://unpkg.com/lucide-static@0.462.0/icons/crown.svg');-webkit-mask-size:contain;mask-size:contain;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;-webkit-mask-position:center;mask-position:center;"></span>${t(lang, "guardianConfirmedBadge")}</span>`
        : "";
      marker.bindPopup(`${badgeHtml(t(lang, "sourceCommunity"))}<br><b>${t(lang, cat.key)}</b><br>${escapeHtml(r.bairro)}<br>${timeAgoLabel(r.createdAt, lang)} · ${confirms}${trustHtml}${stageHtml}${guardianHtml}${relatedHtml}${voteButtonsHtml(lang, r.id, confirms, (myTrustLevel || 0) >= 1)}${shareButtonHtml(lang, "vigiShareReportToCommunity", `'${escapeHtml(r.id)}'`)}`);
      byId[r.id] = marker;
      return marker;
    });
    markersByIdRef.current = byId;
  }, [reports, news, lang, sourceFilter, exploreByHour, turno, myTrustLevel]);

  React.useEffect(() => {
    const map = mapRef.current;
    choroplethLayersRef.current.forEach((l) => map && map.removeLayer(l));
    choroplethLayersRef.current = [];
    if (!map || !showHeatmap || !bairroPolygons) return;
    // News counts too, not just user reports — with so few reports right
    // now, ranking on reports alone made the heatmap mostly noise (a bairro
    // with real, recent violent-crime coverage could still show green just
    // because nobody had filed an in-app report for it yet).
    const allBairroKeys = Object.keys(bairroPolygons).map(stripAccentsJs);
    const { counts, rankByKey } = computeBairroRanks([...reports, ...news], allBairroKeys, Date.now());
    Object.entries(bairroPolygons).forEach(([name, rings]) => {
      const key = stripAccentsJs(name);
      const rank = rankByKey[key];
      const count = counts[key] || 0;
      // Every bairro gets a color now — one with nothing recent just lands
      // at the calm (green) end of the same scale, instead of the old flat
      // "no data" gray. The popup label still says so honestly (below):
      // green-because-quiet reads differently from green-because-verified-
      // safe, even though the fill color is identical.
      const color = rankToColor(rank);
      const latlngRings = rings.map((ring) => ring.map(([lng, lat]) => [lat, lng]));
      const poly = L.polygon(latlngRings, {
        stroke: true, color: "rgba(255,255,255,0.4)", weight: 1,
        fillColor: color, fillOpacity: 0.62,
      }).addTo(map);
      const riskKey = count === 0 ? "heatNoData" : rank < 0.34 ? "heatRiskLow" : rank < 0.67 ? "heatRiskMid" : "heatRiskHigh";
      poly.bindPopup(`${badgeHtml(t(lang, riskKey))}<br><b>${name}</b><br>${count} ${t(lang, "occurrencesInPeriod")}`);
      choroplethLayersRef.current.push(poly);
    });
  }, [reports, news, showHeatmap, bairroPolygons, lang]);

  React.useEffect(() => {
    const map = mapRef.current;
    if (!map || hasAutoFitRef.current) return;
    const points = [
      ...reports.map((r) => [r.lat, r.lng]),
      ...news.map((n) => [n.lat, n.lng]),
    ];
    if (!points.length) return;
    hasAutoFitRef.current = true;
    map.fitBounds(points, { padding: [24, 24], maxZoom: 15 });
  }, [reports, news]);

  function focusReport(r) {
    const map = mapRef.current;
    const marker = markersByIdRef.current[r.id];
    if (!map || !marker) return;
    map.once("moveend", () => marker.openPopup());
    map.flyTo([r.lat, r.lng], Math.max(map.getZoom(), 15), { duration: 0.6 });
  }

  function locateMe() {
    if (typeof window.isSecureContext !== "undefined" && !window.isSecureContext) {
      showToast && showToast(t(lang, "noLocationInsecure"));
      return;
    }
    if (!navigator.geolocation) {
      showToast && showToast(t(lang, "locateDeniedMsg"));
      return;
    }
    setLocating(true);
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setLocating(false);
        const map = mapRef.current;
        if (!map) return;
        const { latitude, longitude, accuracy } = pos.coords;
        if (userMarkerRef.current) map.removeLayer(userMarkerRef.current);
        if (userAccuracyCircleRef.current) map.removeLayer(userAccuracyCircleRef.current);
        const icon = L.divIcon({
          className: "",
          html: `<div style="width:16px;height:16px;border-radius:50%;background:#4A7DC4;border:3px solid #fff;box-shadow:0 0 0 2px rgba(74,125,196,0.45);"></div>`,
          iconSize: [16, 16],
          iconAnchor: [8, 8],
        });
        userMarkerRef.current = L.marker([latitude, longitude], { icon, zIndexOffset: 1000 }).addTo(map);
        userAccuracyCircleRef.current = L.circle([latitude, longitude], { radius: accuracy, color: "#4A7DC4", weight: 1, fillColor: "#4A7DC4", fillOpacity: 0.08 }).addTo(map);
        map.flyTo([latitude, longitude], Math.max(map.getZoom(), 16), { duration: 0.8 });
      },
      () => {
        setLocating(false);
        showToast && showToast(t(lang, "locateDeniedMsg"));
      },
      { enableHighAccuracy: true, timeout: 8000, maximumAge: 60000 }
    );
  }

  React.useEffect(() => { locateMeRef.current = locateMe; });

  React.useEffect(() => {
    const btn = locateBtnRef.current;
    if (!btn) return;
    btn.title = t(lang, "locateMeTitle");
    btn.style.opacity = locating ? 0.5 : 1;
    btn.style.pointerEvents = locating ? "none" : "auto";
  }, [lang, locating]);

  const generalNews = news.filter((n) => n.bairro === "Maceió");

  React.useEffect(() => { generalNewsOpenRef.current = () => setGeneralNewsOpen(true); });

  React.useEffect(() => {
    const container = generalNewsBtnRef.current;
    if (!container) return;
    container.style.display = generalNews.length > 0 ? "" : "none";
    const badge = container.querySelector(".vigi-general-news-badge");
    if (badge) badge.textContent = generalNews.length > 99 ? "99+" : String(generalNews.length);
    const link = container.querySelector("a");
    if (link) link.title = t(lang, "generalNewsTitle");
  }, [generalNews.length, lang]);

  React.useEffect(() => {
    const map = mapRef.current;
    if (!map) return;
    newsRef.current = news;
    newsMarkersRef.current.forEach((m) => map.removeLayer(m));
    if (sourceFilter === "community") {
      newsMarkersRef.current = [];
      return;
    }
    const newsIcon = (px, py) => L.divIcon({
      className: "",
      html: `<div style="width:20px;height:20px;border-radius:6px;background:var(--color-brand-primary);border:2px solid #fff;box-shadow:var(--shadow-card);display:flex;align-items:center;justify-content:center;transform:translate(${px}px,${py}px)"><span style="display:inline-block;width:11px;height:11px;background-color:#fff;-webkit-mask-image:url('https://unpkg.com/lucide-static@0.462.0/icons/newspaper.svg');mask-image:url('https://unpkg.com/lucide-static@0.462.0/icons/newspaper.svg');-webkit-mask-size:contain;mask-size:contain;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat;-webkit-mask-position:center;mask-position:center;"></span></div>`,
      iconSize: [20, 20],
      iconAnchor: [10, 10],
    });
    function addSingleNewsMarker(n, lat, lng, px, py) {
      const marker = L.marker([lat, lng], { icon: newsIcon(px, py) }).addTo(map);
      const safeTitle = escapeHtml(n.title);
      const safeLink = /^https?:\/\//i.test(n.link || "") ? escapeHtml(n.link) : "#";
      const newsIdx = news.indexOf(n);
      marker.bindPopup(`${badgeHtml(escapeHtml(n.outlet))}<br><b>${safeTitle}</b><br>${escapeHtml(n.bairro || "")}<br><a href="${safeLink}" data-link="${safeLink}" onclick="window.vigiOpenNewsArticle(this.getAttribute('data-link'));return false;" rel="noreferrer">${t(lang, "readFullArticleAt")} ${escapeHtml(n.outlet)} →</a>${shareButtonHtml(lang, "vigiShareNewsToCommunity", newsIdx)}`);
      newsMarkersRef.current.push(marker);
    }

    const groups = {};
    news.forEach((n, idx) => {
      // City-wide items with no specific bairro (bairro === "Maceió", the
      // fallback pin) get their own button + list instead of a marker in
      // the middle of the map — see generalNews/GeneralNewsControl above.
      if (n.bairro === "Maceió") return;
      const key = n.bairro ? stripAccentsJs(n.bairro) : `__solo_${idx}`;
      (groups[key] || (groups[key] = [])).push(n);
    });

    newsMarkersRef.current = [];
    Object.values(groups).forEach((group) => {
      if (group.length > 1 && group.length <= NEWS_CLUSTER_THRESHOLD) {
        const key = stripAccentsJs(group[0].bairro);
        const matchName = bairroPolygons && Object.keys(bairroPolygons).find((k) => stripAccentsJs(k) === key);
        const rings = matchName ? bairroPolygons[matchName] : null;
        if (rings) {
          const points = spreadInPolygon(rings, group.length, group[0].lat, group[0].lng);
          group.forEach((n, i) => addSingleNewsMarker(n, points[i][0], points[i][1], 0, 0));
        } else {
          const pixelOffsets = spreadOverlappingPoints(group, (n) => n.lat, (n) => n.lng);
          group.forEach((n, i) => addSingleNewsMarker(n, n.lat, n.lng, pixelOffsets[i][0], pixelOffsets[i][1]));
        }
      } else if (group.length > NEWS_CLUSTER_THRESHOLD) {
        const { lat, lng } = group[0];
        const icon = L.divIcon({
          className: "",
          html: `<div style="width:26px;height:26px;border-radius:50%;background:var(--color-brand-primary);border:2px solid #fff;box-shadow:var(--shadow-card);display:flex;align-items:center;justify-content:center;color:#fff;font-family:var(--font-body);font-weight:700;font-size:12px;">${group.length}</div>`,
          iconSize: [26, 26],
          iconAnchor: [13, 13],
        });
        const marker = L.marker([lat, lng], { icon }).addTo(map);
        const itemsHtml = group.map((n) => {
          const safeTitle = escapeHtml(n.title);
          const safeOutlet = escapeHtml(n.outlet);
          const safeLink = /^https?:\/\//i.test(n.link || "") ? escapeHtml(n.link) : "#";
          const newsIdx = news.indexOf(n);
          return `<details style="margin-top:6px;border-top:1px solid var(--color-border);padding-top:4px;">
            <summary style="cursor:pointer;font-size:12.5px;font-weight:600;">${safeTitle}</summary>
            <div style="padding:4px 0 6px 10px;font-size:12px;color:var(--color-text-secondary);">${safeOutlet}<br><a href="${safeLink}" data-link="${safeLink}" onclick="window.vigiOpenNewsArticle(this.getAttribute('data-link'));return false;" rel="noreferrer">${t(lang, "readFullArticleAt")} ${safeOutlet} →</a>${shareButtonHtml(lang, "vigiShareNewsToCommunity", newsIdx)}</div>
          </details>`;
        }).join("");
        marker.bindPopup(`<div style="max-height:240px;overflow-y:auto;min-width:210px;"><b>${escapeHtml(group[0].bairro)}</b> · ${group.length} ${t(lang, "newsInBairro")}${itemsHtml}</div>`);
        newsMarkersRef.current.push(marker);
      } else {
        const n = group[0];
        addSingleNewsMarker(n, n.lat, n.lng, 0, 0);
      }
    });
  }, [news, lang, sourceFilter, bairroPolygons]);

  return (
    <React.Fragment>
      <div style={{ padding: "6px 14px 10px", display: "flex", gap: 6, overflowX: "auto" }}>
        {visibleFilters.map((f) => <Chip key={f.id} active={filter === f.id} onClick={() => setFilter(f.id)}>{t(lang, f.key)}</Chip>)}
      </div>
      <div style={{ position: "relative", height: 240, flex: "none", zIndex: 0, overflow: "hidden" }}>
        <div ref={mapDivRef} style={{ position: "absolute", inset: 0, background: "#0D1B2C" }} />
        <MapLegend items={[{ label: t(lang, "legendHigh"), tone: "alert" }, { label: t(lang, "legendMid"), tone: "warning" }, { label: t(lang, "legendOther"), tone: "neutral" }]} />
        {showSignupBanner && (
          <div style={{
            position: "absolute", top: 10, left: 10, right: 10, zIndex: 1000,
            background: "var(--color-bg)", border: "1px solid var(--color-brand-primary)",
            borderRadius: "var(--radius-lg)", padding: 12, boxShadow: "0 4px 16px rgba(0,0,0,0.4)",
          }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 8 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 6, fontWeight: "var(--weight-semibold)", fontSize: "var(--text-sm)", color: "var(--color-text-primary)" }}>
                <Icon name="user-plus" size={16} color="var(--color-brand-primary)" />
                {t(lang, "signupBannerTitle")}
              </div>
              <button onClick={onDismissSignupBanner} style={{ background: "transparent", border: "none", cursor: "pointer", padding: 2, flexShrink: 0 }}>
                <Icon name="x" size={16} color="var(--color-text-muted)" />
              </button>
            </div>
            <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-secondary)", marginTop: 4, marginBottom: 10 }}>
              {t(lang, "signupBannerBody")}
            </div>
            <Button
              variant="primary"
              onClick={() => { if (window.changeTab) window.changeTab("perfil"); if (onDismissSignupBanner) onDismissSignupBanner(); }}
              style={{ width: "100%" }}
            >
              {t(lang, "signupBannerCta")}
            </Button>
            <button
              onClick={() => { window.__vigialOpenLogin = true; if (window.changeTab) window.changeTab("perfil"); if (onDismissSignupBanner) onDismissSignupBanner(); }}
              style={{ width: "100%", background: "transparent", border: "none", cursor: "pointer", padding: "8px 0 0", fontSize: "var(--text-xs)", color: "var(--color-text-muted)", fontFamily: "var(--font-body)" }}
            >
              {t(lang, "signupBannerLoginCta")}
            </button>
          </div>
        )}
      </div>
      <div style={{ padding: "4px 14px 0", fontSize: "var(--text-xs)", color: "var(--color-text-muted)" }}>
        {t(lang, "legendNote")}
      </div>
      {exploreByHour && (
        <div style={{ padding: "8px 14px 0" }}>
          <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", marginBottom: 6 }}>{t(lang, "hourExplorerHint")}</div>
          <div style={{ display: "flex", gap: 6, overflowX: "auto" }}>
            {TURNOS.map((tu) => <Chip key={tu.id} active={turno === tu.id} onClick={() => setTurno(tu.id)}>{t(lang, tu.key)}</Chip>)}
          </div>
        </div>
      )}
      <div style={{ padding: "10px 14px", borderTop: "1px solid var(--color-border)", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <span style={{ fontSize: "var(--text-sm)", color: "var(--color-text-secondary)" }}>
          <b style={{ color: "var(--color-text-primary)" }}>{(sourceFilter === "news" ? 0 : reports.length) + (sourceFilter === "community" ? 0 : news.length)}</b> {t(lang, "occurrencesInPeriod")}
        </span>
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <button
            onClick={() => setShowHeatmap((v) => !v)}
            title={t(lang, showHeatmap ? "hideHeatmap" : "showHeatmap")}
            style={{
              display: "flex", alignItems: "center", padding: "6px 8px", borderRadius: "var(--radius-pill)",
              border: `1px solid ${showHeatmap ? "var(--color-brand-primary)" : "var(--color-border)"}`,
              background: showHeatmap ? "var(--color-brand-tint)" : "transparent", cursor: "pointer",
            }}
          >
            <Icon name="flame" size={14} color={showHeatmap ? "var(--color-brand-deep)" : "var(--color-text-secondary)"} />
          </button>
          <button
            onClick={() => setExploreByHour((v) => !v)}
            title={t(lang, exploreByHour ? "hideHourExplorer" : "showHourExplorer")}
            style={{
              display: "flex", alignItems: "center", padding: "6px 8px", borderRadius: "var(--radius-pill)",
              border: `1px solid ${exploreByHour ? "var(--color-brand-primary)" : "var(--color-border)"}`,
              background: exploreByHour ? "var(--color-brand-tint)" : "transparent", cursor: "pointer",
            }}
          >
            <Icon name="clock" size={14} color={exploreByHour ? "var(--color-brand-deep)" : "var(--color-text-secondary)"} />
          </button>
          <div style={{ position: "relative" }}>
            <button
              onClick={() => setSourceMenuOpen((v) => !v)}
              title={t(lang, "mapSourceLabel")}
              style={{ display: "flex", alignItems: "center", gap: 3, padding: "6px 8px", borderRadius: "var(--radius-pill)", border: "1px solid var(--color-border)", background: "transparent", cursor: "pointer" }}
            >
              <Icon name={(SOURCE_OPTIONS.find((o) => o.id === sourceFilter) || SOURCE_OPTIONS[0]).icon} size={14} color="var(--color-text-secondary)" />
              <Icon name="chevron-down" size={11} color="var(--color-text-muted)" />
            </button>
            {sourceMenuOpen && (
              <div style={{
                position: "absolute", bottom: "calc(100% + 4px)", right: 0, minWidth: 190, zIndex: 30,
                background: "var(--color-surface)", border: "1px solid var(--color-border)", borderRadius: 9, boxShadow: "var(--shadow-modal)",
              }}>
                {SOURCE_OPTIONS.map((opt) => (
                  <button
                    key={opt.id}
                    onClick={() => { setSourceFilter(opt.id); setSourceMenuOpen(false); }}
                    style={{
                      display: "flex", alignItems: "center", gap: 8, width: "100%", padding: "8px 10px", boxSizing: "border-box",
                      background: sourceFilter === opt.id ? "var(--color-brand-tint)" : "transparent", border: "none", cursor: "pointer",
                      fontFamily: "var(--font-body)", fontSize: "var(--text-sm)", textAlign: "left",
                      color: sourceFilter === opt.id ? "var(--color-brand-deep)" : "var(--color-text-primary)",
                    }}
                  >
                    <Icon name={opt.icon} size={14} color={sourceFilter === opt.id ? "var(--color-brand-deep)" : "var(--color-text-secondary)"} />
                    <span>{t(lang, opt.key)}</span>
                  </button>
                ))}
              </div>
            )}
          </div>
          <Button variant="alert" size="sm" onClick={onOpenReport}><Icon name="plus" size={13} color="#fff" /> {t(lang, "reportar")}</Button>
        </div>
      </div>
      <div style={{ padding: "0 14px 14px", flex: 1, overflowY: "auto" }}>
        <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", margin: "6px 0" }}>{t(lang, "recentOccurrences")}</div>
        {(() => {
          const recentReports = sourceFilter === "news" ? [] : reports.map((r) => ({ isNews: false, sortAt: r.createdAt, data: r }));
          const recentNews = sourceFilter === "community" ? [] : news.map((n) => ({ isNews: true, sortAt: n.publishedAt || 0, data: n }));
          const merged = [...recentReports, ...recentNews].sort((a, b) => b.sortAt - a.sortAt).slice(0, 5);
          return merged.map((item) => {
            if (item.isNews) {
              return <NewsRowCard key={item.data.link} lang={lang} n={item.data} />;
            }
            const r = item.data;
            const cat = CATS.find((c) => c.id === r.category) || CATS.find((c) => c.id === "outro");
            const related = findRelatedNews(r, news);
            return <OccurrenceRowCard key={r.id} lang={lang} label={r.bairro ? `${t(lang, cat.key)} · ${r.bairro}` : t(lang, cat.key)} timeAgo={timeAgoLabel(r.createdAt, lang)} confirms={r.confirms} tone={cat.tone} onConfirm={() => onConfirm(r.id)} onDislike={() => onDislike(r.id)} onLocate={() => focusReport(r)} related={related} guardianConfirmed={r.guardianConfirmed} canDownvote={(myTrustLevel || 0) >= 1} />;
          });
        })()}
      </div>
      {generalNewsOpen && (
        <Modal title={t(lang, "generalNewsTitle")} onClose={() => setGeneralNewsOpen(false)} width={330}>
          <div style={{ padding: "10px 16px 16px" }}>
            <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", marginBottom: 10 }}>{t(lang, "generalNewsHint")}</div>
            {generalNews.map((n, i) => (
              <div key={i} style={{ padding: "9px 0", borderTop: i > 0 ? "1px solid var(--color-border)" : "none" }}>
                <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", marginBottom: 3 }}>{n.outlet} · {timeAgoLabel(n.publishedAt, lang)}</div>
                <div style={{ fontSize: "var(--text-sm)", color: "var(--color-text-primary)", marginBottom: 4 }}>{n.title}</div>
                <a href={n.link} onClick={(e) => { e.preventDefault(); window.vigiOpenNewsArticle(n.link); }} target="_blank" rel="noreferrer" style={{ fontSize: "var(--text-xs)", color: "var(--color-brand-primary)" }}>{t(lang, "readFullArticleAt")} {n.outlet} →</a>
              </div>
            ))}
          </div>
        </Modal>
      )}
      {shareReport && (
        <ShareToCommunityModal lang={lang} report={shareReport} onClose={() => setShareReport(null)} showToast={showToast} />
      )}
    </React.Fragment>
  );
}
window.CATS = CATS; window.FILTERS = FILTERS; window.windowMs = windowMs; window.timeAgoLabel = timeAgoLabel; window.seedReports = seedReports; window.MapaScreen = MapaScreen;
window.computeBairroRanks = computeBairroRanks; window.rankToColor = rankToColor; window.TONE_COLOR = TONE_COLOR;
window.spreadOverlappingPoints = spreadOverlappingPoints;
window.badgeHtml = badgeHtml;
window.escapeHtml = escapeHtml;
